/**
 * The names of the skins.
 *
 * Rule: this file has no import. The search parsers of the debug views import it, and the route configs load
 * those parsers outside the code-split chunk, so an import here ships in the main bundle.
 */
export const SKINS = ["plain", "blur", "neon", "card"] as const;

export type Skin = (typeof SKINS)[number];

/** The skin of an element without a `SkinProvider` above it. */
export const DEFAULT_SKIN: Skin = "plain";
